import React from "react";
import HomeBanner from "../components/HeroBanner";
import FAQ from "../components/FAQ";

function Home({ faqs }) {
  return (
    <div>
      <HomeBanner />
      {/* <Carousel /> */}
      <div className="spaceline"></div>
      <FAQ faqs={faqs} />
      <div className="spaceline"></div>
    </div>
  );
}

export default Home;
